const featureFlagsQueryKeys = {
  all: ["featureFlags"] as const,
  featureFlagList: () => [...featureFlagsQueryKeys.all, "list"] as const,
};

export default featureFlagsQueryKeys;
